import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPasswordPage() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const token = sp.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please log in.");
      navigate("/login");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="min-h-[calc(100vh-72px)] flex items-center justify-center py-16 px-5" data-testid="reset-page">
      <div className="w-full max-w-md bg-white rounded-3xl border border-[#E3E8E8] shadow-soft p-8">
        <Link to="/"><Logo /></Link>
        <h1 className="font-display font-extrabold text-3xl text-[#0B1733] mt-6">Set a new password</h1>
        {!token ? (
          <p className="mt-4 text-sm text-red-600">Missing reset token. Use the link from your reset email.</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div><Label htmlFor="pw">New password</Label><Input id="pw" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} data-testid="reset-password-input" className="mt-1.5 h-11" /></div>
            <Button type="submit" data-testid="reset-submit-btn" className="w-full h-11 rounded-full bg-[#007F83] hover:bg-[#006B70] text-white">Update password</Button>
          </form>
        )}
      </div>
    </div>
  );
}
